import {mapActions, mapState, mapGetters} from 'vuex'
import dateUtils from '../../../../common/utils/dateUtil'
import * as ReturnMessageConstants from '../../../../constants/ReturnMessageConstants'
import * as RoleCodeConstants from '../../../../constants/RoleCodeConstants'
import {checkReturnStatus} from '../../../../common/utils/return-message-util'
import moment from 'moment'

export default {
  data () {
    return {
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() + 8.64e7
        }
      },
      memberId: 0,
      activeName: 'first',
      canClick: true,
      content: '获取验证码',
      totalTime: 60,
      memberInfoForm: {
        memberName: '',
        memberPhoneNumber: '',
        mileage: '',
        carNumber: '',
        vehicleName: '',
        verificationCode: '',
        remarks: '',
        reservationType: '保养',
        serviceConsultantName: '',
        reservationTime: ''
      },
      carNumbers: [],
      memberInfoRules: {
        memberPhoneNumber: [
          {required: true, message: '请输入手机号', trigger: 'blur'},
          {pattern: /^1[0-9]{10}$/, message: '请输入11位手机号'}
        ],
        carNumber: [
          {required: true, message: '请输入车牌号', trigger: 'blur'}
        ],
        reservationTime: [
          {required: true, message: '请输入预约时间', trigger: 'blur'}
        ]
      },
      carTypeList: ['A1', 'A3', 'A4', 'A5', 'A6', 'A7', 'A8', 'Q2', 'Q3', 'Q5', 'Q7', 'Q8', 'S3', 'TT', 'R8']
    }
  },
  computed: {
    ...mapState('cancelCouponModule', ['staffInfos', 'appointmentRecord']),
    ...mapState('wxMemberModule', ['memberDetail']),
    ...mapGetters('wxMemberModule', ['memberVerificationStatus']),
    consumedCouponInfoList () {
      return this.appointmentRecord
    },
    appointmentTypes () {
      return [
        {
          label: '保养',
          value: '保养'
        },
        {
          label: '维修',
          value: '维修'
        }
      ]
    },
    vinCodeToUpperCase: {
      get: function () {
        return this.memberInfoForm.vinCode
      },
      set: function (val) {
        this.memberInfoForm.vinCode = val.toUpperCase()
      }
    },
    carNumberToUpperCase: {
      get: function () {
        return this.memberInfoForm.carNumber
      },
      set: function (val) {
        this.memberInfoForm.carNumber = val.toUpperCase()
      }
    },
    vehicleNameToUpperCase: {
      get: function () {
        return this.memberInfoForm.vehicleName
      },
      set: function (val) {
        this.memberInfoForm.vehicleName = val.toUpperCase()
      }
    },
    memberDetailInfo () {
      if (this.memberDetail) {
        this.memberInfoForm.memberName = this.memberDetail.memberName
        this.memberId = this.memberDetail.id
        this.memberInfoForm.memberPhoneNumber = this.memberDetail.phoneNumber
        if (this.memberDetail.memberCarDTOList && this.memberDetail.memberCarDTOList.length > 0) {
          this.memberInfoForm.carNumber = this.memberDetail.memberCarDTOList[0].carNumber
        }
        this.carNumbers = this.memberDetail.memberCarDTOList
        return this.memberDetail
      } else {
        return {
          memberName: '',
          memberPhoneNumber: '',
          carNumber: '',
          vehicleName: '',
          captcha: '',
          memberCarDTOList: [
          ]
        }
      }
    },
    staffs () {
      return this.staffInfos
    }
  },
  methods: {
    ...mapActions('cancelCouponModule', ['getStaff', 'commitApplication', 'getMemberAppointmentInfo']),
    ...mapActions('wxMemberModule', ['getMemberDetail', 'getCaptcha']),
    dateFormat (time) {
      return time ? moment(time).format('YYYY/MM/DD') : ''
    },
    handleClick () {
      let data = {
        memberId: this.memberId
      }
      this.getMemberAppointmentInfo(data)
    },
    async getCode () {
      if (!this.memberInfoForm.memberPhoneNumber) {
        this.$message.warning('请输入手机号后再发送验证码')
        return
      }
      let data = {
        phoneNumber: this.memberInfoForm.memberPhoneNumber
      }
      const result = await this.getCaptcha(data)
      if (result && result.code === ReturnMessageConstants.REPEAT_VERIFICATION_CODE) {
        this.$message.warning('已发送验证码，请三分钟之后在重新发送')
        return
      }
      this.setTime()
    },
    setTime () {
      if (!this.canClick) return // 如果是false 直接return出去
      this.canClick = false
      this.content = this.totalTime + 's'
      let clock = window.setInterval(() => {
        this.totalTime--
        this.content = this.totalTime + 's'
        if (this.totalTime < 0) {
          window.clearInterval(clock)
          this.content = '获取验证码'
          this.totalTime = 60
          this.canClick = true // 这里重新开启
        }
      }, 1000)
    },
    waitApprove () {
      this.$refs['memberForm'].validate(async (valid) => {
        if (valid) {
          this.memberInfoForm.carNumber.toUpperCase()
          const result = await this.commitApplication(this.memberInfoForm)
          if (!checkReturnStatus(result)) return
          if (result.data && (result.data.code === ReturnMessageConstants.FAIL_CODE ||
            result.data.code === ReturnMessageConstants.FAIL_CODE_NO_CAR ||
            result.data.code === ReturnMessageConstants.FAIL_CODE_REPEAT_PHONE_NUMBER)) {
            this.$message.error(`${result.data.info}`)
          } else {
            this.$message.success('添加预约成功')
            this.memberInfoForm = {
              memberName: '',
              phoneNumber: '',
              mileage: '',
              carNumber: '',
              vehicleName: '',
              verificationCode: '',
              remarks: '',
              reservationType: '保养',
              serviceConsultantName: ''
            }
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
  mounted () {
    this.getMemberDetail()
    this.getStaff(RoleCodeConstants.RECEPTIONIST_STAFF)
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/cancel-coupon/views/create-make-an-appointment.js